import React from "react";

import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarHeader,
  useSidebar
} from "@/components/ui/sidebar";
import HeaderBox from "./headerBox";
import WorkspaceSwitch from "./workspaceSwitch";
import { Separator } from "../ui/separator";
import TrialCreditExhaustionMessageCard from "./trialCreditExhaustionMessageCard";
import SessionNav from "./sessionNav";
import MainNav from "./mainNav";
import NavUser from "./navUser";






export default function AppSidebar() {
  const { open } = useSidebar();
  

  return (
    <Sidebar collapsible="icon" className="flex flex-col">
      <SidebarHeader className="px-8 pt-4">
        <HeaderBox />
        {open && <WorkspaceSwitch />}
      </SidebarHeader>

      <Separator />

      <SidebarContent className="flex-1 flex flex-col px-2">
        <TrialCreditExhaustionMessageCard />
        <SessionNav />
        <div className="mt-auto">
        <Separator className="my-2" />
        <MainNav />
        </div>
      </SidebarContent>

      <Separator />

      <SidebarFooter className="p-4 mb-2">
        <NavUser />
      </SidebarFooter>
    </Sidebar>
  );
}
